window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');

require('jquery-animate-scroll');

window.cookie = require('js-cookie');
window.swal = require('sweetalert2');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// 3rd party libraries
require('./../unify/vendors/appear');
require('./../unify/vendors/slick-carousel/slick');
require('./../unify/vendors/cubeportfolio/js/jquery.cubeportfolio');
require('./../unify/vendors/dzsparallaxer/dzsparallaxer');
require('./../unify/vendors/dzsparallaxer/dzsscroller/scroller');
require('./../unify/vendors/dzsparallaxer/advancedscroller/plugin');
require('./../unify/vendors/fancybox/jquery.fancybox');
require('./../unify/vendors/master-slider/source/assets/js/masterslider.min');
window.Isotope = require('./../unify/vendors/isotope/isotope.min');


// // JS UNIFY
require('./../unify/js/hs.core');
require('./../unify/js/components/hs.header');
require('./../unify/js/helpers/hs.hamburgers');
require('./../unify/js/components/hs.scroll-nav');
require('./../unify/js/components/hs.counter');
require('./../unify/js/components/hs.carousel');
require('./../unify/js/components/hs.cubeportfolio');
require('./../unify/js/components/hs.popup');
require('./../unify/js/components/hs.go-to');

require('./../unify/vendors/owl/owl.carousel.min');

import JSShare from "js-share";

const shareItems = document.querySelectorAll('.social_share');
for (let i = 0; i < shareItems.length; i += 1) {
    shareItems[i].addEventListener('click', function share(e) {
        return JSShare.go(this);
    });
}

if (document.getElementById('team')) {
    // init Isotope
    var iso = new window.Isotope('.grid', {
        itemSelector: '.element-item',
        layoutMode: 'fitRows'
    });


    window.addEventListener('load', function () {
        iso.arrange({filter: '*'});
    });

    // filter functions
    var filterFns = {
        // show if number is greater than 50
        numberGreaterThan50: function (itemElem) {
            var number = itemElem.querySelector('.number').textContent;
            return parseInt(number, 10) > 50;
        },
        // show if name ends with -ium
        ium: function (itemElem) {
            var name = itemElem.querySelector('.name').textContent;
            return name.match(/ium$/);
        }
    };


    // bind filter button click
    var filtersElem = document.querySelector('.filters-button-group');

    filtersElem.addEventListener('click', function (event) {
        // only work with buttons
        // if ( !matchesSelector( event.target, 'button' ) ) {
        //     return;
        // }

        var filterValue = event.target.getAttribute('data-filter');
        // use matching filter function
        filterValue = filterFns[filterValue] || filterValue;
        iso.arrange({filter: filterValue});
    });
}

if (document.getElementById('dynasty-slider')) {
    var fullHeight = function () {

        $('.js-fullheight').css('height', $(window).height());
        $(window).resize(function () {
            $('.js-fullheight').css('height', $(window).height());
        });

    };
    fullHeight();

    var carousel = function () {
        $('.home-slider').owlCarousel({
            loop: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            margin: 0,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            nav: true,
            dots: false,
            items: 1,
            navText: ["<div class='nav-btn prev-slide'><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z\" /></svg></div>", "<div class='next-slide'><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z\" /></svg></div>"],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        });

    };
    carousel();
}


window.addEventListener("load", function () {
    if (document.getElementById('preloader')) {
        document.getElementById('preloader').remove();
    }

    if (document.getElementById('home')) {
        document.getElementById('home').classList.remove('preloading');
    }
});

//
// // change is-checked class on buttons
// var buttonGroups = document.querySelectorAll('.button-group');
// for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
//     var buttonGroup = buttonGroups[i];
//     radioButtonGroup( buttonGroup );
// }
//
// function radioButtonGroup( buttonGroup ) {
//     buttonGroup.addEventListener( 'click', function( event ) {
//         // only work with buttons
//         if ( !matchesSelector( event.target, 'button' ) ) {
//             return;
//         }
//         buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
//         event.target.classList.add('is-checked');
//     });
// }

